// @flow
import React, { Fragment, PureComponent } from 'react';
import { Redirect } from 'react-router-dom';

import SelectInput from 'components/fragments/input/SelectInput';
import TextInputMaterial from 'components/fragments/input/material/TextInputMaterial';
import TextareaInputMaterial from 'components/fragments/input/material/TextareaInputMaterial';
import Loading from 'components/fragments/Loading';

import { validateEmail } from 'utils/validatorUtils';
import { getFileNameFromPath, convertQueryStringToContactObject } from 'utils/urlUtils';
import { dynamicClassName } from 'utils/dynamicClassName';
import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';

import type { ContactFormType } from 'types/ContactForm';
import type { Status } from 'types/Status';
import type { JobFiltersType, JobFilterType } from 'types/JobFilter';

export type StateProps = {
  contactForm: Array<ContactFormType>,
  sendStatus: Status,
  fetchStatus: Status,
  jobFilters: JobFiltersType
};

export type DispatchProps = {
  postContactForm: (formInputs: Object, id: number) => void,
  fetchContactForm: () => void,
  fetchJobFilters: () => void
};

type Props = {
  location: any,
  history: any
} & StateProps &
  DispatchProps;

type State = {
  name: string | null,
  club: string | null,
  poste: string | null,
  duration: string | null,
  contract: string | null,
  location: string | null,
  detail: string | null,
  email: string | null,
  object: string,
  profil: string | null,
  file: string | null,
  message: string,
  error: string
};

class ContactFormOffre extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    name: null,
    poste: null,
    club: null,
    duration: null,
    contract: null,
    location: null,
    detail: null,
    email: null,
    profil: null,
    object: 'Proposition de poste',
    file: null,
    message: '',
    error: ''
  };

  componentDidMount = () => {
    const {
      fetchContactForm,
      fetchJobFilters,
      location: { search }
    } = this.props;

    if (search !== '') {
      const query = convertQueryStringToContactObject(search, { poste: null, profil: null });
      let { poste, profil } = query;

      poste = Array.isArray(poste) ? poste[0] : poste;
      profil = Array.isArray(profil) ? profil[0] : profil;

      this.setState({ poste, profil });
    }

    fetchContactForm();
    fetchJobFilters();
  };

  _convertToOptions = (jobFilter: Array<JobFilterType>): Array<Object> => {
    return jobFilter.map(filterjob => ({ label: filterjob.name, value: filterjob.name }));
  };

  _handleChange = (name: string, value: string) => {
    this.setState({ [name]: value });
  };

  setFile = (e: any) => {
    const file = e.target.value;
    this.setState({ file });
  };

  setMessage = (e: any) => {
    const message = e.target.value;
    this.setState({ message });
  };

  isFileValid = () => {
    // eslint-disable-next-line
    const input: any = document.querySelector('input[type="file"]');
    if (input) {
      const documentData = input.files[0];
      return !documentData || documentData.type === 'application/pdf';
    } else return false;
  };

  isFormValid = () => {
    const { object, profil, poste, duration, contract, location, name, email } = this.state;

    if (
      object === null ||
      object === '' ||
      profil === null ||
      profil === '' ||
      poste === null ||
      poste === '' ||
      ((duration === null || duration === '') && contract !== 'CDI') ||
      contract === null ||
      contract === '' ||
      location === null ||
      location === '' ||
      name === null ||
      name === '' ||
      email === null ||
      !validateEmail(email)
    ) {
      return false;
    }

    return true;
  };

  handleSubmit = (e: MouseEvent) => {
    e.preventDefault();
    const { postContactForm } = this.props;
    const { name, club, poste, duration, contract, location, detail, email, profil, object } = this.state;

    this.setState({ error: '' });

    if (this.isFormValid()) {
      if (this.isFileValid()) {
        const formId = this._getFormId();

        const input: any = document.querySelector('input[type="file"]');
        var documentData: HTMLInputElement = input.files[0];
        // eslint-disable-next-line
        const formData = {
          'offre-nom': name ? name : '',
          'offre-poste': poste ? poste : '',
          'offre-duree': contract !== 'CDI' && duration ? duration : 'Indéfini',
          'offre-contrat': contract ? contract : '',
          'offre-localisation': location ? location : '',
          'offre-detail': detail ? detail : '',
          'offre-nom-club': club && profil === 'Dirigeant de club' ? club : '',
          'offre-email': email ? email : '',
          'offre-qui': profil ? profil : '',
          'offre-objet': object ? object : '',
          'offre-file': documentData,
          _wpcf7_unit_tag: formId
        };

        postContactForm(formData, formId);
      } else {
        this.setState({
          error: 'Vous ne pouvez envoyer que des fichiers .pdf'
        });
      }
    } else {
      this.setState({
        error: 'Veuillez vérifier le contenu du formulaire',
        object: object === null ? '' : object,
        profil: profil === null ? '' : profil,
        name: name === null ? '' : name,
        email: email === null ? '' : email,
        poste: poste === null ? '' : poste,
        duration: duration === null ? '' : duration,
        location: location === null ? '' : location,
        contract: contract === null ? '' : contract
      });
    }
  };

  _getFormId = () => {
    const { contactForm } = this.props;

    if (contactForm && contactForm.length > 0) {
      const offreForm = contactForm.filter(form => form.title === 'offre');

      if (offreForm && offreForm.length > 0) {
        return offreForm[0].id;
      }
    }

    return 0;
  };

  _renderDurationInput = () => {
    const { contract, duration } = this.state;

    if (contract === 'CDI') {
      return (
        <TextInputMaterial
          id="duration"
          isLight
          placeholder="Durée de contrat"
          label="Durée de contrat"
          disable
          defaultValue={''}
        />
      );
    }
    return (
      <SelectInput
        isLight
        placeholder={`Durée de contrat*`}
        options={[
          { label: '3 mois', value: '1 mois' },
          { label: '6 mois', value: '6 mois' },
          { label: '12 mois', value: '12 mois' },
          { label: 'Autre', value: 'Autre' }
        ]}
        onChange={(value: string) => this._handleChange('duration', value)}
        hasError={duration === ''}
        errorMessage={'Ce champ est requis'}
      />
    );
  };

  _renderFileLabel = () => {
    const { file } = this.state;

    if (file) {
      return <span>{getFileNameFromPath(file)}</span>;
    }

    return (
      <Fragment>
        <span>Ajouter un fichier **</span> ou glissez-le ici
      </Fragment>
    );
  };

  render() {
    const {
      fetchStatus,
      sendStatus,
      jobFilters: { typesContrats }
    } = this.props;

    const { object, profil, name, email, poste, contract, location, error } = this.state;

    if (fetchStatus !== STATUS_SUCCESS) {
      return <Loading isWhite />;
    }

    if (sendStatus === STATUS_SUCCESS && fetchStatus === STATUS_SUCCESS) {
      return <Redirect to="/ffr/carriere" />;
    }

    const classNamesSend = dynamicClassName('btn btn--primary js-contact-send');
    sendStatus === STATUS_LOADING && classNamesSend.add('is-disabled');

    return (
      <div className="form-contact block-contact__form" style={{ display: 'block' }}>
        <h3 className="mb-1">Votre demande</h3>
        <p className="mb-3">Remplissez les champs ci-dessous pour contacter la fédération.</p>
        <form action="#">
          <TextInputMaterial
            id="object"
            isLight
            placeholder="Objet de ma demande"
            label="Objet de ma demande"
            disable
            defaultValue={object}
          />
          <div className="form-contact__row">
            <div className="form-contact__input">
              <TextInputMaterial
                id="poste"
                isLight
                placeholder="Poste recherché*"
                label="Poste recherché*"
                defaultValue={poste}
                errorMessage="Ce champ est requis"
                hasError={poste !== null && poste.length === 0}
                onChange={(value: string) => this._handleChange('poste', value)}
              />
            </div>

            <div className="form-contact__select">
              <SelectInput
                isLight
                placeholder="Type de contrat *"
                options={this._convertToOptions(typesContrats)}
                onChange={(value: string) => this._handleChange('contract', value)}
                hasError={contract === ''}
                errorMessage={'Ce champ est requis'}
              />
            </div>
          </div>
          <div className="form-contact__row">
            <div className="form-contact__select">{this._renderDurationInput()}</div>

            <div className="form-contact__input">
              <TextInputMaterial
                id="location"
                isLight
                placeholder="Localisation*"
                label="Localisation*"
                errorMessage="Ce champ est requis"
                hasError={location !== null && location === ''}
                onChange={(value: string) => this._handleChange('location', value)}
              />
            </div>
          </div>

          <TextareaInputMaterial
            id="yagd917"
            placeholder="Détails de la mission"
            label="Détails de la mission"
            isLight
            customClassname="form-contact__textarea"
            onChange={(value: string) => this._handleChange('detail', value)}
          />
          <div className="box box--smoke input--file form-contact__file">
            <i className="icon icon-pj" />
            <label htmlFor="file">{this._renderFileLabel()}</label>
            <input id="file" name="inputFile" type="file" onChange={this.setFile} />
          </div>

          <div className="form-contact__row">
            <div className="form-contact__select">
              <SelectInput
                isLight
                placeholder="Je suis..."
                options={[
                  { label: 'Licencié', value: 'Licencié' },
                  { label: 'Dirigeant de club', value: 'Dirigeant de club' },
                  { label: 'Entraineur', value: 'Entraineur' },
                  { label: 'Parent de joueur', value: 'Parent de joueur' },
                  { label: 'Journaliste', value: 'Journaliste' },
                  { label: 'Autre', value: 'Autre' }
                ]}
                defaultValue={profil}
                onChange={(value: string) => this._handleChange('profil', value)}
                hasError={profil === ''}
                errorMessage={'Ce champ est requis'}
              />
            </div>

            <div className="form-contact__input">
              <TextInputMaterial
                id="name"
                isLight
                placeholder="Nom complet*"
                label="Nom complet*"
                errorMessage="Ce champ est requis"
                hasError={name !== null && name.length === 0}
                onChange={(value: string) => this._handleChange('name', value)}
              />
            </div>
          </div>

          {profil === 'Dirigeant de club' && (
            <div className="form-contact__row is-right">
              <div className="form-contact__other is-other">
                <TextInputMaterial
                  id="yagdf398438"
                  placeholder="Nom du club"
                  label="Nom du club"
                  onChange={(value: string) => this._handleChange('club', value)}
                />
              </div>
            </div>
          )}

          <TextInputMaterial
            id="email"
            isLight
            placeholder="Adresse mail*"
            label="Adresse mail*"
            errorMessage={email === '' ? 'Ce champ est requis' : "Cet e-mail n'est pas valide"}
            hasError={email !== null && !validateEmail(email)}
            onChange={(value: string) => this._handleChange('email', value)}
          />
          <div className="form-action">
            <div>
              {error ? (
                <p>
                  <span>{error}</span>
                </p>
              ) : (
                sendStatus === STATUS_SUCCESS && (
                  <p>
                    <span style={{ color: '#4CB848', fontSize: '18px' }}>Votre demande a bien été envoyée</span>
                  </p>
                )
              )}
              <p className="ft-tertiary">* champs obligatoires</p>
              <p className="ft-tertiary ft-black-secondary">** taille max : 5 Mo</p>
            </div>
            <div>
              <button className="ft-500 ft-black-secondary" type="reset" onClick={() => this.props.history.goBack()}>
                Annuler
              </button>
              <button className="btn btn--primary js-contact-send" type="button" onClick={this.handleSubmit}>
                Envoyer mon message
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default ContactFormOffre;
